import { BASE_URL } from '@/environment/environment'

export function toMediaUrl(path?: string | null): string {
  if (!path) {
    return ''
  }

  if (
    path.startsWith('blob:')
    || path.startsWith('data:')
    || path.startsWith('http://')
    || path.startsWith('https://')
    || path.startsWith('//')
  ) {
    return path
  }

  if (!BASE_URL) {
    return path
  }

  const separator = path.startsWith('/') ? '' : '/'

  return `${BASE_URL}${separator}${path}`
}
